import React from 'react';
import { BellRing } from 'lucide-react';
import { HostSettingsCard, HostToggleRow } from './HostSettingsCard';

/**
 * Renders a role-specific block of Web Push toggles. The toggle config is
 * provided by the backend (`notification_prefs_config` in
 * /api/account/settings) so labels & keys stay in sync.
 *
 * Like the bucket toggles, these only gate OS-level lock-screen pushes —
 * the in-app bell still shows everything.
 */
export default function RoleNotificationPrefsCard({
  role,
  config,
  notifications,
  onToggle,
  testIdPrefix,
}) {
  const items = config?.[role] || [];
  if (!items.length) {
    return null;
  }
  return (
    <HostSettingsCard data-testid={`${testIdPrefix}-card`}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
        <BellRing size={22} color="var(--text)" />
        <p style={{ fontFamily: "'Inria Serif', serif", fontSize: 18, color: 'var(--text)', margin: 0 }}>Notification Preferences</p>
      </div>
      <p style={{ fontFamily: "'Inria Serif', serif", fontSize: 13, color: '#777', margin: '0 0 10px 0' }}>
        Each toggle controls lock-screen push for that category. The in-app bell always shows everything.
      </p>
      {items.map((item) => (
        <HostToggleRow
          key={item.key}
          label={item.label}
          description={item.description}
          checked={notifications[item.key] !== false}
          onChange={() => onToggle(item.key)}
          dataTestId={`${testIdPrefix}-${item.key}-toggle`}
        />
      ))}
    </HostSettingsCard>
  );
}
